import * as React from "react";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectHighlightingRules } from "views/logic/slices/highlightSelectors";
import HighlightingRulesContext from "./HighlightingRulesContext";
const useHighlightingRules = () => useViewsSelector(selectHighlightingRules);
const HighlightingRulesProvider = ({ children }) => {
  const highlightingRules = useHighlightingRules();
  return highlightingRules ? /* @__PURE__ */ React.createElement(HighlightingRulesContext.Provider, { value: highlightingRules }, children) : children;
};
export default HighlightingRulesProvider;
